function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
  className: styles["cls-1"] || "cls-1",
  d: "M22 2h-3V0h-2v2H7V0H5v2H2a2 2 0 00-2 2v1h24V4a2 2 0 00-2-2zM0 22a2 2 0 002 2h20a2 2 0 002-2V6H0zM18 8h3v3h-3zm0 5h3v3h-3zm0 5h3v3h-3zM13 8h3v3h-3zm0 5h3v3h-3zm0 5h3v3h-3zM8 8h3v3H8zm0 5h3v3H8zm0 5h3v3H8zM3 8h3v3H3zm0 5h3v3H3zm0 5h3v3H3z"
})));